/* File for snippet JS */

/* Help-Center Accordion */
function arrowToggle(e){
  var answer = e.parentElement.querySelector('.help-center__answer-wrap')
  e.querySelector('.accordion-arrow').classList.toggle('open')
  if (answer.style.maxHeight) {
      answer.style.maxHeight = null;
    } else {
      answer.style.maxHeight = answer.scrollHeight + "px";
      var allQs = document.querySelectorAll('.help-center__question-wrap')
      for(let i = 0; i < allQs.length; i++){
        if(allQs[i].querySelector('.accordion-arrow').classList.contains('open') && allQs[i].querySelector('.help-center__question') !== e){
          allQs[i].querySelector('.accordion-arrow').classList.toggle('open')
          allQs[i].querySelector('.help-center__answer-wrap').style.maxHeight = null
        }
      }
    }
}